<template>
    
        <v-card flat class="mx-auto" color="#f1f1f1" height="100%">
            <v-container>
                <v-row>
                    <v-col cols="12" lg="4" class="px-0" order-lg="1" order="2" order-sm="2">
                        <v-card color="#ffffff" elevation="8" class="pa-5" height="100%">
                            <v-img :src="require('./../assets/VULlogo.png')" contain width="100" height="100" class="mx-auto"></v-img>
                            <div class="mt-8">
                                <v-list dense>
                                    <v-list-item>
                                        <v-list-item-icon class="mr-2">
                                            <v-icon color="primary">mdi-email</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>
                                                admissions@vul.edu
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-icon class="mr-2">
                                            <v-icon color="primary">mdi-phone</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-subtitle>
                                                +1 434-528-5276
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item>
                                        <v-list-item-icon class="mr-2">
                                            <v-icon color="primary">mdi-map-marker</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-subtitle class="break-spaces">
                                                2058 Garfield Avenue Lynchburg, VA 24501
                                            </v-list-item-subtitle>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                                <div class="text-center mt-4">
                                    <v-btn icon>
                                        <v-icon medium color="primary">
                                            mdi-facebook
                                        </v-icon>
                                    </v-btn>
                                    <v-btn icon class="mx-2">
                                        <v-icon medium color="primary">
                                            mdi-instagram
                                        </v-icon>
                                    </v-btn>
                                    <v-btn icon>
                                        <v-icon medium color="primary">
                                            mdi-linkedin
                                        </v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </v-card>
                    </v-col>
                    <v-col cols="12" lg="8" class="px-0" order-lg="2" order="1" order-sm="1">
                        <v-card class="pa-5" elevation="8" color="primary">
                            <v-card-title class="white--text">
                                Application for DHA
                            </v-card-title>
                            <v-card-text>
                                <v-form ref="form" v-model="valid" class="mt-4">
                                    <label for="Name" class="label_style">Name</label>
                                    <v-text-field v-model="name" :rules="nameRules" dark filled dense clearable class="mb-4">
                                        <template v-slot:message="{message}">
                                            <span class="white--text letter-spacing-1 font-12">
                                                {{message}}
                                            </span>
                                        </template>
                                    </v-text-field>
                                    <label for="Email Address" class="label_style">Email Address</label>
                                    <v-text-field v-model="emailaddress" :rules="emailRules" dark filled dense clearable class="mb-4">
                                        <template v-slot:message="{message}">
                                            <span class="white--text letter-spacing-1 font-12">
                                                {{message}}
                                            </span>
                                        </template>
                                    </v-text-field>
                                    <label for="Phone No" class="label_style">Phone No</label>
                                    <v-text-field v-model="phoneno" :rules="phoneRules" dark filled dense clearable class="mb-8">
                                        <template v-slot:message="{message}">
                                            <span class="white--text letter-spacing-1 font-12">
                                                {{message}}
                                            </span>
                                        </template>
                                    </v-text-field>
                                    <v-btn color="white" @click="submitForm" class="mt-8 primary--text" absolute bottom right style="right: 32px;" 
                                    rounded width="148px" :loading="loading">Submit</v-btn>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            <Snackbar :snackbar.sync="modal" :message.sync="message" v-on:closeSnackbar="closeSnackbar"></Snackbar>
        </v-card>
</template>
<script>
    import Snackbar from './Snackbar.vue'
    export default {
        data(){
            return{
                name: '',
                emailaddress: '',
                phoneno: '',
                valid: true,
                nameRules: [
                    v => !!v || '*Required'
                ],
                emailRules: [
                    v => !!v || '*Required',
                    v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                ],
                phoneRules: [
                    v => !!v || '*Required'
                ],
                modal: false,
                message: '',
                loading: false
            }
        },
        components: {
            Snackbar
        },
        methods: {
            submitForm(){
                if(this.$refs.form.validate()){
                    this.loading = true;
                    let url = 'https://script.google.com/macros/s/AKfycby3gG3U26NJJXJoMp2Ew5cPjlHPIMtk70l-i6p5fzc7X5zqLgUD9PVaPQKoxN7D5mk/exec?name='+this.name+
                    '&email_address='+this.emailaddress+'&phoneno='+this.phoneno;
                    fetch(url, {method: 'GET'}).then((response) => {
                        console.log(`response`, response);
                        this.$refs.form.reset();
                        this.message = 'Thank you! We will get back to you.';
                        this.modal = true;
                        this.loading = false;
                    }).catch((error) => {
                        console.log(error);
                        this.message = 'Something went wrong!';
                        this.modal = true;
                        this.loading = false;
                    });
                }
                else{
                    this.message = 'Please fill in the required details';
                    this.modal = true;
                }
            },
            closeSnackbar(value){
                this.modal = value;
            }
        }
    }
</script>

<style>
    .grey-bg{
        background-color: #f1f1f1;
    }
    .h-100vh{
        height: 100vh;
    }
    .label_style{
        letter-spacing: 1px;
        text-transform: uppercase;
        font-size: 12px;
        color: white;
        font-weight: 300;
    }
    .letter-spacing-1{
        letter-spacing: 1px;
    }
    .font-12{
        font-size: 12px;
    }
    .break-spaces{
        white-space: break=spaces !important;
    }
</style>